import { render, staticRenderFns } from "./MainInfo.vue?vue&type=template&id=13a5744e"
import script from "./MainInfo.vue?vue&type=script&lang=js"
export * from "./MainInfo.vue?vue&type=script&lang=js"
import style0 from "./MainInfo.vue?vue&type=style&index=0&id=13a5744e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports